const GAME_PARTS = {
    WinLines: Symbol('WinLines'),
    WinController: Symbol('WinController'),
    FreeSpins: Symbol('FreeSpins'),
    ReSpin: Symbol('ReSpin'),
    Spread: Symbol('Spread'),
    TouchZone: Symbol('TouchZone'),
    // InfoPages: Symbol("InfoPages"),
    Searching: Symbol('Searching'),
    Freespins: Symbol('Freespins'),
    IdleWin: Symbol('IdleWin'),
    BigWin: Symbol('BigWin'),
    Counter: Symbol('Counter'),
    IdleAnimation: Symbol('IdleAnimation'),
    Scatter: Symbol('Scatter'),    
    Board: Symbol('Board'),
};
export default GAME_PARTS;
